import { CategoryFilterKey, CategoryFilterModel } from '../domain';
import { useFilter } from '../../filter';

export const useCategoryListFilter = () => {
  return useFilter(
    CategoryFilterKey,
    'categoryFilter',
    (filter: string) => new CategoryFilterModel(filter),
    true
  );
};
